import { Buffer } from "buffer";

export const encodePackage = (packageData) => {
  // Convert to base64
  let str1 = Buffer.from(packageData).toString("base64");
  let char1 = str1.substring(0, 4);
  let char2 = str1.substring(str1.length - 4);
  let char3 = str1.substring(4, str1.length - 4);
  let data = char2 + char3 + char1;
  data = "FIN" + data + "SPOT";
  return data;
};

export const decodePackag = (packageData) => {
  const charFin = packageData.substring(0, 3);
  const charSpot = packageData.substring(packageData.length - 4);
  let data = "";

  if (charFin === "FIN" && charSpot === "SPOT") {
    const data_ = packageData.substring(3, packageData.length - 4);
    const split1 = data_.substring(0, 4);
    const split2 = data_.substring(data_.length - 4);
    const base64 = split2 + data_.substring(4, data_.length - 4) + split1;

    // Convert base64 to ASCII string
    const binaryData = Buffer.from(base64, "base64");
    const asciiString = new TextDecoder().decode(binaryData);
    data = asciiString;
  }

  return data;
};
